import { useMutation } from "react-query";
import { addDataConnection } from "../../../../../actions/Utilities/DataConnection";
import { toast } from "components/toastNotification";
import { IDataCon } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import {
  addStateDataConnection,
  dataConnectionReFetching,
} from "../atoms/atoms";

const useAddDataConnection = () => {
  const setIsAddState = useSetRecoilState(addStateDataConnection);
  const [isReFetching, setIsReFetching] = useRecoilState(
    dataConnectionReFetching
  );

  const { mutate } = useMutation(
    (NewData: IDataCon) => addDataConnection(NewData),
    {
      onSuccess: (res: any) => {
        if (typeof res == "object") {
          toast.fire("Adding Data Connection failed", res.Message, "error");
        } else {
          switch (true) {
            case res == "Success":
              toast.fire(
                "Success",
                "Data Connection Added Successfully",
                "success"
              );
              break;
            case res.includes("Notification insert Failed"):
              toast.fire(
                "Success ",
                `Data Connection Added Successfully, BUT ${res}`,
                "warning"
              );
              break;
            case res == "Operation Failed!":
              toast.fire(
                "Adding Data Connection failed ",
                `Server Error: ${res}`,
                "error"
              );
              break;
            case res == "The data already exists!":
              toast.fire(
                "Adding Data Connection failed",
                `Duplication Error: ${res}`,
                "error"
              );
              break;
            default:
              toast.fire("Adding Data Connection failed", res, "error");
          }
        }

        // Redirect to View
        setIsAddState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },

      onError: (error: any) => {
        toast.fire("Add Data Connection failed", `Error: ${error}`, "error");
      },
    }
  );

  return mutate;
};
export default useAddDataConnection;
